export default [
  [
    {
      id: 'repairId',
      label: 'เลขที่ใบแจ้งซ่อมที่เกี่ยวข้อง',
      type: 3.1,
      span: 4,
      offset: 0,
      props: { padding: '8px 0' },
    }, {
      id: 'supplierId',
      label: 'ผู้จำหน่าย',
      type: 3.3,
      span: 4,
      props: { padding: '8px 0' },
    }, {
      id: 'department',
      label: 'แผนก',
      type: 0,
      span: 4,
      props: { padding: '8px 0' },
    }, {
      id: 'deadlineDate',
      label: 'วันที่ครบกำหนด *',
      span: 4,
      offset: 8,
      type: 8,
      props: { padding: '8px 0' },
    },
  ], [
    {
      id: 'Items',
      label: 'สินค้าที่ต้องการเสนอซื้อ *',
      type: 3.2,
      span: 24,
      offset: 0,
      props: {
        margin: '0 0 16px 0', padding: '8px 0', width: '100%', title: { text: 'เบอร์ยาง *' },
      },
    },
  ], [
    {
      id: 'remark',
      span: 24,
      type: 7,
      label: 'หมายเหตุ',
      props: { padding: '8px 0' },
    },
  ],
]
